import { render } from "./LandingFeedPreview.vue?vue&type=template&id=13fd8478&scoped=true"
import script from "./LandingFeedPreview.vue?vue&type=script&lang=js"
export * from "./LandingFeedPreview.vue?vue&type=script&lang=js"

import "./LandingFeedPreview.vue?vue&type=style&index=0&id=13fd8478&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../../../Users/jamarrucho/Documents/2024/04_Unit/Dev/unit-org_2025_10_24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13fd8478"]])

export default __exports__